<template>
  <div :class="`type-${type}`" class="swiper-wrap">
    <div class="swiper-container">
      <div class="swiper-wrapper">
        <div
          v-for="(banner, index) in bannerList"
          :key="index"
          class="swiper-slide"
        @click.stop="openOthers(banner)">
          <img
            :src="getPic(banner,'png')"
            @error="defaultImg()"
          />
          <div class="mask"></div>
        </div>
      </div>
    </div>
    <div :class="[`${paginationAlign}_dot`,`dot-type-${type}`]" class="swiper-pagination"></div>
    <div v-if="pnBtn" class="swiper-button-prev"></div>
    <div v-if="pnBtn" class="swiper-button-next"></div>
  </div>
</template>

<script>
import 'swiper/css/swiper.css';
import Swiper from 'swiper';

export default {
  name: 'HomeSwiper',
  components: {},
  props: {
    /**
     * bannerList: 返回数组
     * type: 类型-不同样式
     * titleAlign: pagination对齐方式 left right center
     */
    bannerList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    type: {
      type: Number,
      default: 1,
    },
    delayTime: {
      type: Number,
      default: 3000,
    },
    paginationAlign: {
      type: String,
      default: 'center'
    },
    querySelector: {
      type: String,
      default: ''
    },
    pnBtn: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      imgSwiper: null,
      activeIndex: -1,
    };
  },
  watch: {},
  created() {
  },
  mounted() {
    this.init();
  },
  activated() {
    this.init();
  },
  methods: {
    defaultImg() {
      var img = event.srcElement;
      img.onerror = null; // 解绑onerror事件
    },
    openOthers(item) {
      if (this.type === 1 || this.type === 3) {
        window.open(item.link, '_blank');
      }
    },
    init() {
      if (this.type === 1 || this.type === 3) {
        this.initSwiper();
      } else if (this.type === 2) {
        this.initSwiper2();
      } else if (this.type === 4) {
        this.initSwiper4();
      }
    },
    initSwiper() {
      if (this.imgSwiper) {
        this.imgSwiper.destroy();
      }
      const _this = this;
      this.imgSwiper = new Swiper(this.querySelector + '.swiper-wrap .swiper-container', {
        autoplay: {
          disableOnInteraction: false, // 手动滑动之后不打断播放
          delay: _this.delayTime
        },
        // loop: true,
        pagination: {
          el: this.querySelector + '.swiper-wrap .swiper-pagination',
          type: 'bullets'
        }
      });
    },
    initSwiper2() {
      if (this.imgSwiper) {
        this.imgSwiper.destroy();
      }
      this.imgSwiper = new Swiper(this.querySelector + '.swiper-wrap .swiper-container', {
        // autoplay: {
        //   disableOnInteraction: false, // 手动滑动之后不打断播放
        //   delay: _this.delayTime
        // },
        // loop: true,
        watchSlidesProgress: true,
        slidesPerView: 'auto',
        centeredSlides: true,
        loop: true,
        loopedSlides: 5,
        autoplay: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        pagination: {
          el: this.querySelector + '.swiper-wrap .swiper-pagination',
          type: 'bullets'
        },
        on: {
          progress: function (swiper, progress) {
            for (let i = 0; i < this.slides.length; i++) {
              const slideProgress = this.slides[i].progress;
              let slide = this.slides.eq(i);
              let modify = 1, translate = '', scale = 0, zIndex = 0, perspective = 0, rotateY = 0;
              if (Math.abs(slideProgress) > 1) {
                modify = (Math.abs(slideProgress) - 1) * 0.3 + 1;
              }
              translate = slideProgress * modify * 16.8 + 'rem';
              scale = 1 - Math.abs(slideProgress) / 2.6;
              zIndex = 999 - Math.abs(Math.round(10 * slideProgress));
              perspective = Math.abs(slideProgress) === 1 ? 1 : 0;
              rotateY = slideProgress === 1 ? 20 : slideProgress === -1 ? -20 : 0;
              slide.css('zIndex', zIndex);
              slide.transform('translateX(' + translate + ') scale(' + scale + ')  perspective(10rem) rotateY(' + rotateY + 'deg)');
              slide.css('opacity', 1);
              //slide.css('transform','translateX(' + translate + ') scale(' + scale + ') perspective(10rem) rotateY(' + rotateY + 'deg)'); //-webkit-transform:translateX(' + translate + ') scale(' + scale + ') perspective(10rem) rotateY(' + rotateY + 'deg);-moz-transform:translateX(' + translate + ') scale(' + scale + ') perspective(10rem) rotateY(' + rotateY + 'deg)';
              //slide.css('-webkit-transform','translateX(' + translate + ') scale(' + scale + ') perspective(10rem) rotateY(' + rotateY + 'deg)');
              //slide.css('-moz-transform','translateX(' + translate + ') scale(' + scale + ') perspective(10rem) rotateY(' + rotateY + 'deg)');
              //slide.css('-o-transform','translateX(' + translate + ') scale(' + scale + ') perspective(10rem) rotateY(' + rotateY + 'deg)');
              if (Math.abs(slideProgress) === 0) {
                slide[0].lastChild.classList.add('transparent');
                slide.css('transform', 'translateZ(' + 9 + 'rem)');
              } else {
                slide[0].lastChild.classList.remove('transparent');
              }
              if (Math.abs(slideProgress) > 1) {
                slide.css('opacity', 0);
              }
            }
          },
          setTransition: function (transition) {
            for (let i = 0; i < this.slides.length; i++) {
              let slide = this.slides.eq(i)
              slide.transition(transition);
            }
          }
        }
      });
    },
    initSwiper4() {
      if (this.imgSwiper) {
        this.imgSwiper.destroy();
      }
      const _this = this;
      this.imgSwiper = new Swiper(this.querySelector + '.swiper-wrap .swiper-container', {
        autoplay: {
          disableOnInteraction: false, // 手动滑动之后不打断播放
          delay: _this.delayTime
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        pagination: {
          el: this.querySelector + '.swiper-wrap .swiper-pagination',
          type: 'bullets'
        }
      });
    },
    getPic(banner, type) {
      // if (this.type === 3) {
      //    return banner.url
      // } else
      if (this.type === 1) {
        return banner.url
        //return require(`img/${banner}.png`);
      } else if (this.type === 2 || this.type === 4) {
        //return require(`img/${banner}.jpg`);
        return `https://scszsj-system.oss-cn-beijing.aliyuncs.com/pic0/${banner}.jpg`;
      } else if (this.type === 3) {
        return banner.url
        //return require(`imgM/${banner}.jpg`);
      } else {
        return `http://tupian.szsjgame.com/tupian/${banner}.${type}`;
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import "~styles/index.less";
@import "~styles/variable.less";

.swiper-wrap {
  position: relative;

  &.type-1 {
    position: absolute;
    left: .5rem;
    top: 0;
    .wh(588, 626);

    .swiper-container {
      .swiper-slide {
        img {
          width: 4.88rem;
          height: 6.26rem;
        }
        cursor: pointer;
      }
    }
  }

  &.type-3 {
    .wh(700, 364);

    .swiper-container {
      .swiper-slide {
        img {
          width: 7rem;
          height: 3.64rem;
        }
      }
      cursor: pointer;
    }
  }

  &.type-2 {
    .swiper-container{
      .wh(1920, 624);
      transform: translateX(-2.4rem);
    }

    .swiper-wrapper {
      transform-style: preserve-3d;

      .swiper-slide {
        position: relative;
        //transform-style: preserve-3d;
        //transform: perspective(10rem);
        img {
          .center();
          //width: 10.86rem;
          //height: 6.11rem;
          width: 10.1rem;
          height: 5.58rem;
          border-radius: .3rem;
        }

        .mask {
          .center();
          width: 10.91rem;
          height: 6rem;
          z-index: 2;
          transform: translate(-5.4rem, -3.15rem);
          .background('~img/box4bg.png');
          opacity: .3;

          &.transparent {
            transform: translate(-5.4rem, -3.15rem);
            width: 10.91rem;
            height: 6rem;
            .background('~img/box4bg.png');
            opacity: 1;
          }
        }
      }
    }
  }

  &.type-4 {
    .wh(708, 430);

    .swiper-container {
      .swiper-wrapper {

        .swiper-slide {
          width: 7.5rem;
          height: 4.3rem;
          img {
            margin-top: .09rem;
            width: 6.9rem;
            height: 3.77rem;
            border-radius: .3rem;
          }

          .mask {
            //.center();
            position: absolute;
            top: -.16rem;
            left: -.15rem;
            width: 7.5rem;
            height: 4.3rem;
            z-index: 2;
            //transform: translate(-3.7rem, -2.2rem);
            .background('~img/box4bg.png');
          }
        }
      }
    }
  }
}

</style>
<style lang="less">
@import "~styles/index.less";
@import "~styles/variable.less";

.swiper-wrap {
  .swiper-pagination {
    width: 100%;

    &.left_dot {
      text-align: left;
    }

    &.center_dot {
      text-align: center;
    }

    &.right_dot {
      text-align: right;
    }

    &.dot-type-1 {
      position: absolute;
      right: -.2rem;
      top: .5rem;
      width: .32rem;
      display: flex;
      flex-direction: column;

      .swiper-pagination-bullet {
        background: #8E8E8E;
        .b-radius(7);
        margin: .16rem 0;
        .wh(16, 16);
        transition: all .1s ease-in-out;
        opacity: 1;
      }

      .swiper-pagination-bullet-active {
        background: #B5A068;
      }
    }

    &.dot-type-3 {
      margin-top: .24rem;

      .swiper-pagination-bullet {
        display: inline-block;
        background: rgba(142, 142, 142, 1);
        border-radius: 50%;
        margin: 0 .11rem;
        .wh(16, 16);
        transition: all .1s ease-in-out;
      }

      .swiper-pagination-bullet-active {
        background: rgba(181, 160, 104, 1);
      }
    }

    &.dot-type-2 {
      margin-top: .44rem;

      .swiper-pagination-bullet {
        display: inline-block;
        margin: 0 .11rem;
        .wh(18, 15);
        .background('~img/5P_dot.png');
        transition: all .1s ease-in-out;
        opacity: 1;
      }

      .swiper-pagination-bullet-active {
        .wh(31, 27);
        .background('~img/5P_dotted.png');
      }
    }

    &.dot-type-4 {
      margin-top: .22rem;

      .swiper-pagination-bullet {
        display: inline-block;
        margin: 0 .26rem;
        .wh(18, 18);
        border-radius: 0;
        .background('~img/5P_dot.png');
        transition: all .1s ease-in-out;
        opacity: 1;
      }

      .swiper-pagination-bullet-active {
        .wh(32, 25);
        .background('~img/5P_dotted.png');
      }
    }
  }

  &.type-2{
    .swiper-button-prev {
      width: .89rem;
      height: .47rem;
      .background('~img/box4arrow.png');
      transform: rotate(180deg);

      &::after {
        content: '';
      }
    }

    .swiper-button-next {
      width: .89rem;
      height: .47rem;
      .background('~img/box4arrow.png');

      &::after {
        content: '';
      }
    }
  }

  &.type-4{
    .swiper-button-prev {
      width: .82rem;
      height: .45rem;
      left: .2rem;
      top: 1.6rem;
      .background('~imgM/box4arrow.png');

      &::after {
        content: '';
      }
    }

    .swiper-button-next {
      width: .82rem;
      height: .45rem;
      right: .2rem;
      top: 1.8rem;
      .background('~imgM/box4arrow.png');
      transform: rotate(180deg);
      &::after {
        content: '';
      }
    }
  }

}

</style>





// WEBPACK FOOTER //
// src/components/homeSwiper/homeSwiper.vue